import axios from "axios";

export const getProductosComercio = async () => {
    return axios.get('api/Comercio/obtenerGrupoDeProductosPorComercio/?agrupado=true')
}

export const getSituacionIvaComercio = async () => {
    return axios.get('api/Comercio/obtenerSituacionIvaComercio')
}

